import React from 'react';
import './VIPFeatures.css';

const VIPFeatures = ({ onClose, onShowPricing }) => {
  const features = [
    {
      id: 1,
      title: "Xem chi tiết ý nghĩa quẻ Dịch",
      description: "Khám phá ý nghĩa sâu sắc của quẻ chính, quẻ biến, quẻ tương ứng với các cặp số, bao gồm diễn giải chi tiết.",
      free: true,
      vip: true
    },
    {
      id: 2,
      title: "Xem chi tiết năng lượng số",
      description: "Khám phá về các loại năng lượng số, dòng chảy năng lượng trong dãy số điện thoại của bạn.",
      free: true,
      vip: true,
      hot: true
    },
    {
      id: 3,
      title: "Xem chi tiết Tổ hợp năng lượng số",
      description: "Hiểu rõ sự tương tác giữa các loại năng lượng số để hiểu dòng năng lượng của bạn.",
      free: false,
      vip: true,
      hot: true,
      new: true
    },
    {
      id: 4,
      title: "Xem ý nghĩa Năng lượng chủ đạo",
      description: "Hiểu rõ về loại năng lượng chủ đạo trong số điện thoại của bạn, ảnh hưởng đến cuộc sống của bạn.",
      free: false,
      vip: true
    },
    {
      id: 5,
      title: "Phân tích tổng quan",
      description: "Giúp bạn có cái nhìn tổng thể về vấn đề bạn đang quan tâm trong cuộc sống.",
      free: false,
      vip: true
    },
    {
      id: 6,
      title: "Xem các cảnh báo đặc biệt",
      description: "Hiểu rõ về các tổ hợp số đặc biệt và ý nghĩa của chúng, giúp bạn chủ động phòng tránh và vượt qua.",
      free: true,
      vip: true,
      new: true,
      hot: true
    },
    {
      id: 7,
      title: "Xem giải pháp chi tiết",
      description: "Nhận được các giải pháp và lời khuyên cụ thể để cải thiện và phát triển bản thân.",
      free: false,
      vip: true
    },
    {
      id: 8,
      title: "Số lượt phân tích",
      description: "Với tài khoản VIP, bạn có thể tùy chọn số lượt phân tích không giới hạn, khác với tài khoản Free chỉ có 9 lượt cố định.",
      free: "9 lượt",
      vip: "Không giới hạn",
      hot: true
    },
    {
      id: 9,
      title: "Tùy chọn Chuyên Gia Luận Giải",
      description: "Trải nghiệm các Chuyên Gia Luận Giải, cho kết quả phân tích chính xác và chi tiết.",
      free: false,
      vip: true,
      hot: true,
      new: true
    }
  ];

  return (
    <div className="vip-features-overlay">
      <div className="vip-features-modal">
        <button className="close-button" onClick={onClose}>✕</button>
        
        <div className="vip-header">
          <h2>
            <span className="crown">👑</span>
            Tính năng VIP
          </h2>
        </div>

        <div className="features-table">
          {features.map(feature => (
            <div key={feature.id} className="feature-row">
              <div className="feature-info">
                <h3>
                  {feature.title}
                  {feature.hot && <span className="hot-badge">HOT</span>}
                  {feature.new && <span className="new-badge">NEW</span>}
                </h3>
                <p>{feature.description}</p>
              </div>
              <div className="feature-availability">
                <div className={`availability-indicator ${feature.free ? 'available' : 'unavailable'}`}>
                  <span className="plan-label">Free</span>
                  {typeof feature.free === 'string' ? feature.free : (feature.free ? '✓' : '✕')}
                </div>
                <div className={`availability-indicator ${feature.vip ? 'available' : 'unavailable'}`}>
                  <span className="plan-label">VIP</span>
                  {typeof feature.vip === 'string' ? feature.vip : (feature.vip ? '✓' : '✕')}
                </div>
              </div>
            </div>
          ))}
        </div>

        <button 
          className="unlock-vip-button-large" 
          onClick={onShowPricing}
        >
          <span>👑</span>
          <span>Nâng cấp VIP ngay</span>
        </button>
      </div>
    </div>
  );
};

export default VIPFeatures;